import { Link2, PencilLine, PlusSquare, Trash } from 'lucide-angular';
import { MenuAction } from '@shared/interfaces/header/menu-action';

export const meterframeOverviewActionMenu: MenuAction[] = [
  {
    id: 'createMeterFrame',
    title: 'connectionPoint.meterFrame.create',
    breaker: false,
    icon: PlusSquare
  },
  {
    id: 'editMeterFrame',
    title: 'connectionPoint.meterFrame.edit',
    icon: PencilLine,
    disabled: true
  },
  {
    id: 'closeMeterFrame',
    title: 'connectionPoint.meterFrame.remove',
    icon: Trash,
    iconColor: 'text-red-500',
    disabled: true,
    breaker: true
  },
  {
    id: 'createMeter',
    title: 'connectionPoint.meterFrame.meter.create',
    icon: PlusSquare
  },

  {
    id: 'addMeterWithoutAttaching',
    title: 'connectionPoint.meterFrame.meter.createmeterwithoutattach',
    icon: PlusSquare
  },

  {
    id: 'attachMeter',
    title: 'connectionPoint.meterFrame.meter.attach',
    disabled: true,
    icon: PlusSquare
  },

  {
    id: 'editMeter',
    title: 'connectionPoint.meterFrame.meter.edit',
    icon: PencilLine,
    disabled: true
  },
  {
    id: 'removeMeter',
    title: 'connectionPoint.meterFrame.meter.remove',
    icon: Trash,
    iconColor: 'text-red-500',
    disabled: true,
  },
  {
    id: 'replaceMeter',
    title: 'connectionPoint.meterFrame.meter.change',
    icon: Link2,
    iconColor: 'text-red-500',
    disabled: true,
    breaker: true,
  },
  {
    id: 'addConversionFactor',
    title: 'meterFrame.actions.addConversionFactor',
    icon: PlusSquare,
    disabled: true,
  },
  {
    id: 'changeQuadrantMapping',
    title: 'meterFrame.actions.changeQuadrantMapping',
    icon: PlusSquare,
    disabled: true,
  },
];
